import { useState } from 'react';
import ModeToggle from '../commonComp/modeToggle';

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 w-full z-50 backdrop-blur-md bg-white/60 dark:bg-neutral-900/60 shadow-sm border-b border-gray-200 dark:border-neutral-700">
      <div className="max-w-7xl mx-auto flex flex-wrap items-center justify-between px-4 py-3">
        {/* Brand / Name */}
        <a
          href="/"
          className="text-2xl font-bold  text-black dark:text-white tracking-tight"
        >
          Pranjal
        </a>

        {/* Toggle button (for mobile) */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          type="button"
          className="md:hidden inline-flex items-center justify-center p-2 rounded-md text-gray-800 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-neutral-700 focus:outline-none focus:ring-2 focus:ring-primary"
          aria-controls="mobile-menu"
          aria-expanded={isOpen}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            {isOpen ? (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            ) : (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            )}
          </svg>
        </button>

        {/* Desktop Nav Links */}
        <div className="hidden md:flex md:items-center space-x-8">
          <NavLinks />
        </div>

        {/* Mode Toggle */}
        <div className="hidden md:block">
          <ModeToggle />
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden px-4 pt-2 pb-4 transition-all duration-300 ease-in-out ${
          isOpen ? 'block' : 'hidden'
        }`}
      >
        <div className="flex flex-col space-y-3 text-base">
          <NavLinks mobile />
          <ModeToggle />
        </div>
      </div>
    </nav>
  );
}

// 🧩 Reusable Nav Links Component
function NavLinks({ mobile = false }) {
  const linkStyle = `block px-3 py-2 rounded-md font-medium text-gray-800 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-neutral-700 transition`;
  const links = [
    { label: 'About Me', href: '#aboutMe' },
    { label: 'Skills', href: '#skills' },
    { label: 'Experience', href: '#experience' },
    { label: 'Achievements', href: '#acheivements' },
    { label: 'Resume', href: '#resume' },
    { label: 'Contact', href: '#contact' },
  ];

  return (
    <>
      {links.map((link) => (
        <a key={link.label} href={link.href} className={linkStyle}>
          {link.label}
        </a>
      ))}
    </>
  );
}
